// extracted by mini-css-extract-plugin
export default {"copyButton":"components_copyButton__SNsE7"};